import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useLocation, useNavigate } from 'react-router-dom';
import { useData } from '../../../contexts/DataContext';
import { exportToPDF } from '../../../utils/exportUtils';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../../common/SafeIcon';

const { FiCheckCircle, FiShield, FiHome, FiDownload, FiPrinter, FiLoader } = FiIcons;

const HMSConfirmation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { reports } = useData();
  const [report, setReport] = useState(null);
  const [isGenerating, setIsGenerating] = useState(false);

  const reportId = location.state?.reportId;
  const passedReportData = location.state?.reportData;

  useEffect(() => {
    if (passedReportData) {
      setReport(passedReportData);
    } else if (reportId && reports.length > 0) {
      const found = reports.find(r => r.id === reportId);
      if (found) setReport(found);
    }
  }, [reportId, passedReportData, reports]);

  const handleDownloadPDF = async (e) => {
    e.preventDefault();
    if (!report) {
      alert('Data mangler. Prøv å laste siden på nytt.');
      return;
    }
    setIsGenerating(true);
    setTimeout(async () => {
      try {
        await exportToPDF(report, 'hms_incident');
      } finally {
        setIsGenerating(false);
      }
    }, 100);
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="max-w-2xl w-full text-center">
        <div className="bg-white rounded-3xl shadow-xl p-10 border border-gray-100">
          <div className="w-20 h-20 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto mb-6">
            <SafeIcon icon={FiCheckCircle} className="text-4xl" />
          </div>
          <h1 className="text-3xl font-black text-gray-900 mb-4">Rapport sendt!</h1>
          <p className="text-gray-600 mb-8 font-medium">Takk for din innsending. Hendelsen er nå registrert og saksbehandler er varslet.</p>
          
          {reportId && (
            <div className="bg-blue-50 border border-blue-100 rounded-2xl p-6 mb-8">
              <p className="text-[10px] font-black text-blue-400 uppercase tracking-widest mb-1">Referansenummer</p>
              <p className="text-3xl font-mono font-black text-blue-900">{reportId}</p>
            </div>
          )}

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
            <button 
              type="button"
              onClick={handleDownloadPDF}
              disabled={isGenerating}
              className="flex items-center justify-center gap-2 bg-gray-900 text-white py-4 rounded-2xl font-black uppercase text-xs tracking-widest hover:bg-black transition-all disabled:opacity-50"
            >
              {isGenerating ? <SafeIcon icon={FiLoader} className="animate-spin" /> : <SafeIcon icon={FiDownload} />}
              {isGenerating ? 'Genererer...' : 'Last ned PDF'}
            </button>
            <button 
              type="button"
              onClick={() => window.print()}
              className="flex items-center justify-center gap-2 bg-white border-2 border-gray-200 text-gray-700 py-4 rounded-2xl font-black uppercase text-xs tracking-widest hover:bg-gray-50 transition-all"
            >
              <SafeIcon icon={FiPrinter} />
              Skriv ut
            </button>
          </div>

          <button 
            type="button"
            onClick={() => navigate('/')}
            className="text-blue-600 font-bold hover:underline flex items-center justify-center gap-2 mx-auto"
          >
            <SafeIcon icon={FiHome} />
            Gå til forsiden
          </button>
        </div>
      </motion.div>
    </div>
  );
};

export default HMSConfirmation;